import React from 'react'
import urlJoin from 'url-join'
import ReactLoading from 'react-loading'
import {useTheme} from '@material-ui/core/styles'
import { STATIC_PATH } from 'src/common/razzle-platform-components/configs'
import './PageLoader.scss'


const PageLoader: React.FC<any> = (props: any) => {
    const theme = useTheme()
    const logoUrl = urlJoin(STATIC_PATH, 'assets/images/loading_page_logo.png')

    return (
        <div id="page-loader">
            <div className="logo">
                <img src={logoUrl} alt="logo" />
            </div>
            <div className="loader">
                <div>
                    <ReactLoading type="bubbles" color={theme.palette.primary.main}  width={75} />
                </div>
            </div>
        </div>
    )
}

export default PageLoader
